export const getRoomTypes = table => {
  if (!Array.isArray(table) || table.length === 0 || !table[0].columns) {
    return []
  }

  return table[0].columns.map(col => col.name)
}
